module.exports = __webpack_public_path__ + "static/media/step1.62d799d0.webp";